import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_PRESENTED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
});

const RECORD = generateSchema(TRACKING_PRESENTED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_PRESENTED_SCHEMA);

export class PresentedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.presented;
  }

  get properties() {
    return this.toJS();
  }
}
